@let commentData = comment();

<div class="p-2">
  <div class="flex items-center">
    <div class="flex-1">
      <strong>{{ commentData.email }}</strong>

      @if (commentData.name; as name) {
        <span>({{ name }})</span>
      }
    </div>

    <span class="text-xs italic">
      {{ commentData.created_at | date: "short" }}
    </span>
  </div>

  <p class="break-all">{{ commentData.content }}</p>
</div>
